













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class GroupSelect extends Vue {
	@Prop({ default: null, required: false }) private model;
	@Prop({ default: null, required: true }) private errors;
	@Prop({ default: 0, required: false }) private min;
	@Prop({ default: 100, required: false }) private max;

	private value = 0;
	private minValue = 0;
	private maxValue = 100;

	mounted() {
		if (this.model) {
			this.value = this.model;
		}
		if (this.min) {
			this.minValue = this.min;
		}
		if (this.max) {
			this.maxValue = this.max;
		}
	}
}
